
export interface ViewAction {

edit(id: string | number):void;
view(id: string | number):void;
list(id: string | number | null):void;
add(id: string | number | null):void;

}